import {processApiRequest} from '../../Common/saga';
import * as ACTION from './constants';
import apiService from '../apiService';

export function* fetchSameDayBags(action) {
    yield processApiRequest(ACTION.FETCH_SAME_DAY_BAGS, () => apiService.getSameDayBags(action.payload.bagId), action.payload);
}
